import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { updateParentId } from "Administrator/modules/AdministratorModule";

import PlannerElementSetConfiguration from "Administrator/commonComponents/PlannerElementSetConfiguration";
import RubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/RubricSetup";
import ChecklistSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/ChecklistSetup";
import SinglePointRubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/SinglePointRubricSetup";
import ScoreBasedRubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/ScoreBasedRubricSetup";
import StandardBasedRubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/StandardBasedRubricSetup";
import WorkbookTemplates from "Administrator/commonComponents/WorkbookTemplates";
import StudentProfileTemplates from "Administrator/commonComponents/StudentProfileTemplates";
import ManageTemplates from "Administrator/commonComponents/ManageTemplates";
import LearnerProfileAttributes from "Administrator/commonComponents/LearnerProfileAttributes";
import ConceptsSetup from "Administrator/routes/AcademicSetup/routes/ConceptsSetup";
import LearnerProfilesSetup from "Administrator/routes/AcademicSetup/routes/LearnerProfilesSetup";
import ActionsSetup from "Administrator/routes/AcademicSetup/routes/ActionSetup";
import Continuum from "Continuum";
import FieldsConfiguration from "Administrator/commonComponents/FieldsConfiguration";
import Atls from "Administrator/commonComponents/Atls";
import Datasets from "Datasets";
import { PypATL } from "./routes";
import MYPKeyConcepts from "Administrator/routes/MYPAcademicSetup/routes/MYPKeyConcepts";
import MYPRelatedConcepts from "Administrator/routes/MYPAcademicSetup/routes/MYPRelatedConcepts";
import AssessmentToolTemplates from "../AssessmentToolTemplates";

export default store => ({
  path: "datasets-and-templates",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  onEnter(nextState, replace) {
    store.dispatch(updateParentId("DATASETS_AND_TEMPLATES"));
  },
  childRoutes: [
    PlannerElementSetConfiguration(store),
    RubricSetup(store),
    ChecklistSetup(store),
    SinglePointRubricSetup(store),
    ScoreBasedRubricSetup(store),
    StandardBasedRubricSetup(store),
    WorkbookTemplates(store),
    StudentProfileTemplates(store),
    ManageTemplates(store),
    LearnerProfileAttributes(store),
    ConceptsSetup(store),
    LearnerProfilesSetup(store),
    ActionsSetup(store),
    Continuum(store),
    FieldsConfiguration(store),
    Atls(store),
    MYPKeyConcepts(store),
    MYPRelatedConcepts(store),
    PypATL(store),
    Datasets(store),
    AssessmentToolTemplates(store),
  ],
});
